import SimRecredential from "../../../services/sim-recredential";
import { LoginState } from "../../../store/login/types";
import { Result } from "../../../store/search/types";

export const requestSimRecredential = async ({
    login,
    selectedEntity,
    simCredentialParams,
    snackbarCallback,
}: {
    login: LoginState;
    selectedEntity: Result | undefined;
    simCredentialParams: any;
    snackbarCallback: Function;
}) => {
    const {
        client,
        envVariables: { deviceWakeUpsV2 },
    } = login;
    const clientAuth: any = client?.authenticate();
    const userId = clientAuth.loginId;
    const simRecredential = new SimRecredential(client, deviceWakeUpsV2);
    try {
        const response = await simRecredential.requestSimRecredential({
            devices: [
                {
                    "deviceKey": selectedEntity?.deviceKey,
                    ...simCredentialParams,
                },
            ],
            userId,
        });
        snackbarCallback({ message: 'Sim Recredentialing successful', variant: 'success' });
        return response;
    } catch {
        snackbarCallback({ message: 'There was an error during sim recredentialing', variant: 'error' });
        return null;
    }
}